import { render, staticRenderFns } from "./CaseConfig.vue?vue&type=template&id=21e5a7f0"
import script from "./CaseConfig.vue?vue&type=script&lang=js"
export * from "./CaseConfig.vue?vue&type=script&lang=js"
import style0 from "./CaseConfig.vue?vue&type=style&index=0&id=21e5a7f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports